"use client"

import { TrackedLeadLink } from "./tracked-lead-link"
import { WhatsAppIcon } from "./icons"
import { useCtaVisibility } from "./use-cta-visibility"

/**
 * On a phone the WhatsApp button should never be more than a thumb away, but it
 * shouldn't cover the footer's own contact details either. The when of that
 * lives in `useCtaVisibility`, shared with the floating desktop button.
 */
export function MobileCtaBar({ whatsappUrl, label }: { whatsappUrl: string; label: string }) {
  const visible = useCtaVisibility()

  if (!visible) {
    return null
  }

  return (
    // Ink, like every other button on the site. The WhatsApp glyph carries
    // the channel; the colour does not need to.
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-rule bg-paper/95 px-4 py-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] backdrop-blur sm:hidden">
      <TrackedLeadLink
        href={whatsappUrl}
        cta="mobile_bottom_bar_whatsapp"
        leadType="whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        className="flex min-h-[52px] w-full items-center justify-center gap-2.5 bg-ink px-4 text-body font-semibold text-paper"
      >
        <WhatsAppIcon className="h-5 w-5 shrink-0" />
        {label}
      </TrackedLeadLink>
    </div>
  )
}
